import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class StockNotice extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateStockNotice);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateStockNotice);
  }

  /**
   * Updates the stock notice when the selected variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateStockNotice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newStockNotice = event.detail.data.html.querySelector(`stock-notice#${CSS.escape(this.id)}`);

    if (!newStockNotice) return;

    morph(this, newStockNotice, { childrenOnly: true });
  };
}

if (!customElements.get('stock-notice')) {
  customElements.define('stock-notice', StockNotice);
}
